// @ts-nocheck
import * as React from "react";

const CheckmarkCircle: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                fill="currentColor"
                d="M12 2l.399.01a10.54 10.54 0 011.971.27 1 1 0 11-.47 1.94l-.376-.077A8.79 8.79 0 0012 4l-.304.005A7.93 7.93 0 006.33 6.36l-.218.229A8 8 0 0012 20l.25-.004A8 8 0 0020 12l.007-.117A1 1 0 0121 11l.117.007A1 1 0 0122 12l-.004.28C21.848 17.673 17.43 22 12 22l-.328-.006A9.93 9.93 0 015 19.09l-.23-.236A10 10 0 0112 2zm6.22 4.34a1 1 0 011.5 1.32l-7 8A1 1 0 0112 16l-.132-.008a1 1 0 01-.578-.282l-3-3-.084-.095A1.004 1.004 0 019.71 11.29L12 13.54z"
            />
        </svg>
    );
};

export default React.memo(CheckmarkCircle);
